module.exports = __webpack_public_path__ + "static/JointOuting18-81048fb797c4e7e64f37ea3cc4d3be60.jpg";